import * as React from "react";

interface RefProps {
    color?: string;
    size?: number;
    active?: boolean;
}

/**
 * Border icon, a square outline. When active, shows a thicker stroke.
 */
export const BorderIcon = React.forwardRef<SVGSVGElement, RefProps>(
    ({ color = "currentColor", size = 24, active = false, ...rest }, ref) => {
        return (
            <svg
                ref={ref}
                xmlns="http://www.w3.org/2000/svg"
                width={size}
                height={size}
                viewBox="0 0 24 24"
                fill="none"
                stroke={color}
                strokeWidth={active ? "3" : "2"}
                strokeLinecap="round"
                strokeLinejoin="round"
                {...rest}
            >
                <rect x="3" y="3" width="18" height="18" rx="2" ry="2" />
                {active && (
                    <rect x="6" y="6" width="12" height="12" rx="1" ry="1" strokeWidth="1" strokeDasharray="2 2" />
                )}
            </svg>
        );
    }
);
